import * as T from './types'

const BrowserTab = (props: T.ISVGProps) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 68 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M53.8333 11.8333H14.1666C12.6018 11.8333 11.3333 13.1018 11.3333 14.6666V54.3333C11.3333 55.8981 12.6018 57.1666 14.1666 57.1666H53.8333C55.3981 57.1666 56.6666 55.8981 56.6666 54.3333V14.6666C56.6666 13.1018 55.3981 11.8333 53.8333 11.8333Z"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 23.1667H56.6666"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.6667 11.8333V23.1666"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default BrowserTab
